import apiRequest from '../../utils/bccampusGraphQLRequest';
import {
  GetTextbooksQuery,
  GetReviewableTextbooksQuery,
  GetTextbookByIdQuery,
  GetTextbookBySlugQuery,
  GetTextbookByUUIDQuery
} from '../queries/Textbooks.graphql';

const read = async (key) => {
  if (key) {
    const parsedKey = Number(key);
    const reUUID = /^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$/;

    if (reUUID.test(key)) return await getByUUID(key);
    else if (isNaN(parsedKey)) return await getBySlug(key);

    return await getById(key);
  }
  else {
    return await getAll();
  }
}

const getById = async (id) => {
  const variables = {
    id: id,
  };
  const result = await apiRequest(GetTextbookByIdQuery, variables);
  return result.textbooks.length === 1 ? result.textbooks[0] : null;
}

const getBySlug = async (slug) => {
  const variables = {
    slug: slug,
  };
  const result = await apiRequest(GetTextbookBySlugQuery, variables);
  return result.textbooks.length === 1 ? result.textbooks[0] : null;
}

const getByUUID = async (uuid) => {
  const variables = {
    uuid: uuid,
  };
  const result = await apiRequest(GetTextbookByUUIDQuery, variables);
  return result.textbooks.length === 1 ? result.textbooks[0] : null;
}

const getAll = async () => {
  const result = await apiRequest(GetTextbooksQuery);
  return result.textbooks;
}

const getAllReviewable = async () => {
  const result = await apiRequest(GetReviewableTextbooksQuery);
  return result.textbooks;
}

const textbooksRepository = { read, getAll, getAllReviewable };

export { read, getAll, getAllReviewable }
export default textbooksRepository
